import React from 'react';
import { Link } from 'react-router-dom';

function CallToActionSection() {
  return (
    <section className="bg-gradient-to-br from-[#1a1a2e] to-[#16213e] text-text-white py-24 text-center">
      <div className="max-w-6xl mx-auto px-5">
        <h2 className="text-5xl font-bold mb-5">Ready to Build Something Amazing?</h2>
        <p className="text-xl text-text-gray mb-10">Let's connect and discuss your next big idea.</p>
        <Link to="/contact" className="bg-accent-red text-text-white rounded-full px-8 py-4 font-bold transition-all duration-300 hover:bg-red-700 hover:-translate-y-0.5">
          Get in Touch
        </Link>
      </div>
    </section>
  );
}

export default CallToActionSection;